
<template>
</template>

<script>

	export default {
    name: 'common-ticker',
		components: {
    },
    data() {
      return {

      }
    },
    props: [

    ],
    methods: {
      start(target) {
        $("#" + target).block({
          message: '<i class="icon-spinner2 icon-2x spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });
      },
      end(target) {
        $("#" + target).unblock();
      }
    },
    created() {
      
    },
    mounted() {

    }
}
</script>
<style  scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/common/common-ticker.vue